export var DcfSdkEnumsObj = {
    MASTERCARD: "MASTERCARD",
    VISA: "VISA",
};
